const capabilities = [
  {
    icon: 'ri-drag-drop-line',
    title: '拖拽式界面设计',
    description: '丰富的组件库和直观的拖拽操作，像搭积木一样构建应用界面，所见即所得的设计体验让每个人都能成为产品设计师。',
  },
  {
    icon: 'ri-database-2-line',
    title: '数据模型可视化',
    description: '无需编写SQL，通过图形化界面定义数据表、字段和关联关系，平台自动生成高性能的数据库结构和API接口。',
  },
  {
    icon: 'ri-flow-chart',
    title: '工作流引擎',
    description: '可视化的业务流程设计器，支持条件分支、审批流转、定时触发等复杂逻辑，让业务自动化变得简单直观。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端自动适配',
    description: '一次设计，自动适配PC端、平板端和移动端。还支持一键生成微信小程序，无需额外开发移动版本。',
  },
  {
    icon: 'ri-plug-line',
    title: '开放集成能力',
    description: '内置丰富的API连接器和第三方服务集成，轻松对接企业微信、钉钉、飞书等办公平台，打破数据孤岛。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '企业级安全防护',
    description: '多重安全机制保障数据安全，包括RBAC权限控制、数据加密传输、操作审计日志，满足企业级安全合规要求。',
  },
];

export default function CapabilitiesSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-sm font-medium mb-4">
            核心能力
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            六大核心能力，重塑开发方式
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto leading-relaxed">
            无码平台将复杂的软件开发过程抽象为简单直观的操作，让业务人员也能轻松驾驭数字化工具。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {capabilities.map((cap, idx) => (
            <div
              key={idx}
              className="group p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${cap.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-3">{cap.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{cap.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}